import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ehsCBAPI } from 'src/environments/environment';

import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  version: string;
  title = 'client';
  currentRoute: string;

  selectedState: any = [
  ];

  constructor(public _router: Router, public _route: ActivatedRoute) { }

  ngOnInit() {

    this.version = ehsCBAPI.version;
    
    $('#sidebarCollapse').on('click', function () {
      $('#sidebar').toggleClass('active');
      $(this).toggleClass('active');
    });
  }

  ngDoCheck() {

    let currentUrl = this._router.url;
    this.currentRoute = "";

    if (currentUrl.indexOf("/topics") > -1) {
      this.currentRoute = "topics";
    }
    if (currentUrl.indexOf("/sub-topics") > -1) {
      this.currentRoute = "sub-topics";
    }
    if (currentUrl.indexOf("/questions") > -1) {
      this.currentRoute = "questions";
    }
    if (currentUrl.indexOf("/word-import") > -1) {
      this.currentRoute = "word-import";
    }

  }

  searchQuestion(searchTerm) {
    this._router.navigate(["/questions/" + searchTerm]);
  }
}
